import { Button, Container, Form, Notification, Section } from 'react-bulma-components';
import React, { Fragment, useEffect, useState } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';

import { GET_SONGS } from './songs';
import Loader from '../components/loader';
import PageTitle from '../components/pagetitle';
import _ from 'lodash';
import { navigate } from '@reach/router';
import { useForm } from '../hooks/formState';
import { useSnackbar } from 'react-simple-snackbar';

const { Control, Field, Input, Label, Select } = Form;

const ADD_SONG = gql`
 mutation addSong($title: String!, $slug: String!, $type: String!, $cloneSongId: String){
  addSong(title: $title, slug: $slug, type: $type, cloneSongId: $cloneSongId)
  {
    success
    message
    songRevision
    {
      title
      slug
      type
    }
  }
}
`;
const ISADMIN = gql`
  query IsAdmin {
    admin
  }
`;

export default function SongAdd({ type }) {
  const [openSnackbar] = useSnackbar();
  const { data: isAdmin, loading: isAdminLoading } = useQuery(ISADMIN,
    {
      fetchPolicy: "no-cache"
    }
  );
  const { data: songsData, loading: songsLoading, error: songsError } = useQuery(GET_SONGS,
    {
      variables:{
        type: type
      }
    });
  const [addSong, { loading: mutationLoading, error: mutationError }] = useMutation(ADD_SONG,
    {
      onError(error) {
        openSnackbar(error.message, 2000);
      },
      onCompleted({ addSong }) {
        openSnackbar(addSong.message, 2000);
        if(addSong.success)
        {
          navigate(`/${type}-edit/${addSong.songRevision.slug}`);
        }
      }
    });

  const [songsList, setSongsList] = useState([]);

  const { values, handleChange, handleSubmit } = useForm((formValues) => submitForm(formValues), {
    title: '',
    slug: '',
    cloneSongId: null
  });
  const handleTitleChange = (evt) => {
    handleChange(evt);
    evt.target = {
      name: "slug",
      value: evt.target.value.toLowerCase().replace(/ /g, '-')
    };
    handleChange(evt);
  }
  const handleCloneChange = (evt) => {
    handleChange(evt);
    evt.target = {
      name: "cloneSongId",
      value: evt.target.value
    };
    handleChange(evt);
  }
  const submitForm = (formValues) => {
    addSong({
      variables:
      {
        title: values.title,
        slug: values.slug,
        type: type,
        cloneSongId: values.cloneSongId,
      }
    })
  }

  useEffect(() => {
    if (songsData && songsData.songs) {
      setSongsList(songsData.songs);
    }
  }, [songsData]);

  if (isAdminLoading) {
    return (
      <Loader delay="0.2" text="Authorizing ..." />
    );
  }
  if (isAdmin && isAdmin.admin !== true) {
    return (
      <Section>
        <Container>
          <Notification color="danger" style={{ textAlign: 'center' }}>
            Not authorized
          </Notification>
        </Container>
      </Section>
    );
  }
  return (
    <Fragment>
      <PageTitle name={`Add a new ${_.upperFirst(type)}`} />
      <Section>
        <form onSubmit={handleSubmit}>
          <Field>
            <Label>{_.upperFirst(type)} title</Label>
            <Control>
              <Input onChange={handleTitleChange} name="title" type="text" placeholder={`The title of the ${type}`} value={values.title} />
            </Control>
          </Field>
          <Field>
            <Label>Slug</Label>
            <Control>
              <Input onChange={handleChange} name="slug" type="text" placeholder={`Unique identifier for this ${type} in the URL`} value={values.slug} />
            </Control>
          </Field>
          <Field>
            <Label>Clone {type}</Label>
            <Control>
              <Select onChange={handleCloneChange} name="cloneSongId" value={null}>
                {songsLoading &&  <option key="0" value={null}>Loading {type}s ...</option> }
                {songsError &&  <option key="0" value={null}>Could not load {type}s</option> }
                {!songsLoading && !songsError &&  <option key="0" value={null}>New empty {type}</option> }
                {songsList.map(song =>
                  <option key={song.id} value={song.id}>{song.title}</option>
                )}
              </Select>
            </Control>
          </Field>
          <Field>
            <Control>
              <Button color="success" type="submit">Create</Button>
            </Control>
          </Field>
        </form>
      </Section>
      {mutationError && <p>Error :( Please try again</p>}
    </Fragment>
  );
}
